<template>
    <div>
        <div :class="{ 'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-max modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4 text-capitalize">
                            {{ sTitle }}
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div id="pdf"></div>
                        <!-- <iframe :src="url"></iframe> -->
                        <a :href="url">{{ url }}</a>
                        <form @submit.prevent="submitForm">
                            <div class="form-group">
                                <label class="form-label">Member Name</label>
                                <input class="form-control" type="text" v-model="name" required :disabled="mconsentID ? true : false">
                                <div v-if="nameError" class="error-validation">{{ nameError }}</div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">Member Mobile</label>
                                <input class="form-control" type="phone" v-model="mobile" required :disabled="mconsentID ? true : false">
                                <div v-if="mobileError" class="error-validation">{{ mobileError }}</div>
                            </div>
                        </form>
                        <br>
                        <canvas height="200" width="350" style="border: 1px solid black">
                        </canvas>
                        <br>
                        <button
                            type="button"
                            class="btn btn-info waves-effect waves-themed ml-2"
                            @click="clearSignature">
                            Clear
                        </button>
                    </div>
                    <div class="modal-footer">
                        <div class="row w-100 no-gutters">
                            <div v-if="mconsentID" class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-danger waves-effect waves-themed mr-2"
                                    @click="showDeleteModal">
                                    Delete
                                </button>
                            </div>

                            <div class="col">
                            </div>
                            <div class="col-auto">
                                <button
                                    type="button"
                                    class="btn btn-secondary waves-effect waves-themed ml-2"
                                    @click="toggleModal = false">
                                    {{ $t('button_link.cancel') }}
                                </button>
                                <button
                                    v-if="mconsentID ? false : true"
                                    type="button"
                                    class="btn btn-primary waves-effect waves-themed ml-2"
                                    @click="submitForm"
                                    :disabled="saveable">
                                    Sign Now
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteFile"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal.vue'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import pdfobject from 'pdfobject'
import SignaturePad from 'signature_pad'
export default {
    name: 'ConsentFormForm',
    props: {
        isEdit: Boolean
    },
    components: {
        DeleteModal,
    },
    data() {
        return {
            toggleModal: false,
            sTitle: '',
            saveable: false,

            member: {},
            name: '',
            mobile: '',
            form: {},
            url: '',
            mconsentID: 0,

            nameError: '',
            mobileError: '',

            signaturePad : null,
        }
    },
    methods: {
        showModal(member, form, consent) {
            console.log(member)
            this.toggleModal = true

            this.member = {}
            this.mobile = ''
            this.name = ''
            this.form = {}
            this.url = ''
            
            if(member) {
                this.member = member
                this.mobile = member['mobile']
                this.name = member['name']
            }

            if(form) {
                this.form = form
                this.url = form['url']
                // pdfobject.embed(form['url'], "#pdf")
            }

            this.signaturePad.clear()
        },
        closeModal(isError) {
        },

        onItemChange() {
            this.$emit('onItemChange')
        },

        clearSignature() {
            this.signaturePad.clear()
        },
        submitForm() {
            console.log(this.member)
            
            this.nameError = ''
            this.mobileError = ''

            if (!this.name) {
                this.nameError = 'Please input consent file title'
                return
            }

            if (!this.mobile) {
                this.mobileError = 'Please select file to upload'
                return
            }

            const formData = new FormData();
            formData.append('file', this.signaturePad.toDataURL("data:image/png;base64"));
            formData.append('name', this.name);
            formData.append('mobile', this.mobile);
            formData.append('memberID', this.member.memberID);
            formData.append('form', this.url);

            let url = 'https://mall.tunai.io'
            // url = 'http://localhost:5001'

            let $vm = this
            $vm.$axios({
                method: 'post',
                url: url + '/signature',
                headers: { token: $vm.$session.get('token') },
                data: formData
            })
                .then((response) => {
                    if (response.status == 200) {
                        if(response.data) {
                            window.open(url + response.data.substring(1), '_blank');
                        }

                        var message = 'Successfully signed ' + this.form.title
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.toggleModal = false

                        this.$emit('onItemChange')
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },

        showDeleteModal() {
            var title = this.$i18n.t('header.delete_file')
            var message = this.$i18n.t('message.confirmation.delete_file')
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteFile() {
            let $vm = this
            $vm.$axios({
                method: 'post',
                url: 'https://bebusiness.tunai.io/consent/' + this.consentID + '/delete',
                headers: { token: $vm.$session.get('token') },
            })
                .then((response) => {
                    if (response.status == 200) {
                        this.toggleModal = false

                        this.sTitle = ''
                        this.title = ''
                        this.file = ''
                        this.$refs['dropzoneEdit'].removeAllFiles()

                        var message = 'Successfully delete consent form'
                        $vm.$parent.$parent.setModal($vm, false, true, message)

                        this.$emit('onItemChange')

                        this.$refs.deleteModal.toggleModal = false
                    }
                })
                .catch((err) => {
                    console.log(err)
                    var errData = err.response.data;
                    if (errData.error == $vm.$api.INVALID_TOKEN) {
                        handleSessionExpired();
                    }
                })
        },
    },
    async mounted() {
        const canvas = document.querySelector("canvas");
        this.signaturePad = new SignaturePad(canvas);
    }
}
</script>
<style scoped>
.error-validation {
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
</style>